import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { stagingURL } from "../../views/Apis";
import { axiosBaseQuery } from "../axiosBaseQuery";

export const clubapi = createApi({
  reducerPath: "clubAPI",
  baseQuery: axiosBaseQuery({ baseUrl: stagingURL }),
  endpoints: () => ({}),
});
